import { createAction, props } from '@ngrx/store'
import { AggregationsState } from '../../store/states/aggregations.state'
import { PlayerPosition } from '@core/enums/player.enums'
import { AggregationSelectable } from '../../models/aggregations.models'

export const initializeAggregations = createAction('[Aggregations] initialize', props<Partial<AggregationsState>>())
export const initializeAggregationsSuccess = createAction(
  '[Aggregations] initialization completed successfully',
  props<{
    newState: AggregationsState
  }>()
)

export const setAggregationIsVsEnabledFlag = createAction(
  '[Aggregations] set isVsEnabled flag',
  props<{ isVsEnabled: boolean }>()
)
export const setAggregationIsMatchFlag = createAction('[Aggregations] set isMatch flag', props<{ isMatch: boolean }>())
export const setAggregation = createAction(
  '[Aggregations] set aggregation',
  props<{ aggregation: AggregationSelectable }>()
)

export const setAggregations = createAction(
  '[Aggregations] set both aggregations',
  props<{ leftAggregation: AggregationSelectable; rightAggregation: AggregationSelectable }>()
)
export const setAggregationsDemarcation = createAction(
  '[Aggregations] set player demarcation',
  props<{ demarcation: PlayerPosition }>()
)

export const setAggregationModes = createAction(
  '[Aggregations] set modes modes',
  props<{ aggregationModes: AggregationSelectable[] }>()
)

export const purgeAggregations = createAction('[Aggregations] purge')
